import React, { useState } from "react";
import { Paper, Typography, Divider, TextField, Button } from "@mui/material";
import CustomDialog from "../../Components/CustomDialog";
import { changePassword } from "../../ApiService/ApiService";

function ChangePassword({ setFirstTimeLogin }) {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [dialogData, setDialogData] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCloseDialog = (buttonName) => {
    setDialogData((prevData) => ({
      ...prevData,
      visible: false,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.newPassword || !formData.confirmPassword) {
      setDialogData({
        visible: true,
        title: "Error",
        message: "Please fill in all the details.",
        buttons: [{ name: "Close", onPress: () => {} }],
      });
      return;
    }
    if (formData.newPassword !== formData.confirmPassword) {
      setDialogData({
        visible: true,
        title: "Error",
        message: "New password and confirm password must match.",
        buttons: [{ name: "Close", onPress: () => {} }],
      });
      return;
    }
    setLoading(true);
    try {
      const response = await changePassword({ password: formData.newPassword });
      console.log("Change Pass", response?.data);
      if (response) {
        if (response?.data?.status === 200) {
          setDialogData({
            visible: true,
            title: "Success",
            message: "Password Changed Successfully",
            buttons: [
              { name: "Close", onPress: () => setFirstTimeLogin(false) },
            ],
          });
          setFormData({
            newPassword: "",
            confirmPassword: "",
          });
          return;
        } else {
          const errorMessage = response?.data?.errorMessage;
          setDialogData({
            visible: true,
            title: "Error",
            message: errorMessage,
            buttons: [{ name: "Close", onPress: () => {} }],
          });
        }
      } else {
        setDialogData({
          visible: true,
          title: "Error",
          message: "Invalid response from the server",
          buttons: [{ name: "Close", onPress: () => {} }],
        });
      }
    } catch (error) {
      if (error?.response) {
        console.log("Failed to change password!", error?.response?.data);
        setDialogData({
          visible: true,
          title: "Error",
          message: error?.response?.data?.error || "Failed to change password!",
          buttons: [{ name: "Close", onPress: () => {} }],
        });
      } else {
        console.log("Failed to change password!", error);
        setDialogData({
          visible: true,
          title: "Error",
          message: "An error occurred while changing the password.",
          buttons: [{ name: "Close", onPress: () => {} }],
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialogData.visible}
        title={dialogData.title}
        message={dialogData.message}
        buttons={dialogData.buttons}
        onClose={handleCloseDialog}
      />
      <Paper
        elevation={3}
        sx={{
          padding: 5,
          boxShadow: "0px 4px 80px rgba(0, 0, 0, 0.1)",
          ml: 5,
        }}
      >
        <form onSubmit={handleSubmit} style={{ display: "block" }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Change Password
          </Typography>
          <Divider sx={{ p: 1 }} />
          <Typography variant="h6" sx={{ color: "gray", textAlign: "center" }}>
            Welcome to{" "}
            <span
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              SchoolMidas
            </span>
          </Typography>

          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            size="small"
            label="New Password"
            name="newPassword"
            type="password"
            value={formData.newPassword}
            onChange={handleChange}
            required
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            size="small"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ textTransform: "unset", mt: 2, height: "50px" }}
            disabled={loading}
          >
            {loading ? "Loading..." : "Change Password"}
          </Button>
        </form>
      </Paper>
    </>
  );
}

export default ChangePassword;
